import { SOCIAL_PROVIDERS } from 'constants/registration';
import { CREATOR_ENVIRONMENT, CREATOR_EQUIPMENT } from 'constants/profile';
import { Address, Creator } from './creator';
import { User } from './user';
import { CreatorReview } from './review';

export type CreatorProfileType = 'public' | 'iframe' | 'personal';

export type CreatorProfile = Pick<
  Creator,
  | 'ageRange'
  | 'socials'
  | 'portfolio'
  | 'socialCategories' // "creatorCategories"
  | 'contentCategories' // "creatorSkills"
  | 'jobTypes'
  | 'username'
  | 'about'
  | 'equipment'
  | 'environment'
> & {
  address: Pick<Address, 'city' | 'state'>;
  overallRating?: number;
  totalReviews?: number;
  // IDs
  userId: string;
  creatorId: string;
} & Pick<User, 'firstName' | 'lastName' | 'profilePicture'>;

export type PublicProfileResponse = CreatorProfile & {
  partnershipCreditCost: number;
  // Rating Stats
  contentQuality?: number;
  professionalism?: number;
  reviews: Array<CreatorReview>;
  // Instagram Stats
  instagramStats: {
    followers?: number;
    avgComments?: number;
    avgLikes?: number;
  };
};

export type CreatorLevelProgress = {
  level: LevelSchema;
  completedPartnershipCount: number;
};

export type PersonalProfileResponse = CreatorProfile & CreatorLevelProgress;

export interface LevelSchema {
  name: string;
  description: string;
  image: string;
  lowerBoundCompletedCampaigns: number;
  upperBoundCompletedCampaigns: number;
}

export type ProfileUpdates = Partial<
  Omit<CreatorProfile, 'portfolio' | 'jobTypes'>
>;

export type SettingsResponse = Omit<CreatorProfile, 'portfolio'> &
  Pick<Creator, 'payPalEmail' | 'address'>;

export type CreatorEquipment = (typeof CREATOR_EQUIPMENT)[number];

export type CreatorEnvironment = (typeof CREATOR_ENVIRONMENT)[number];

export const isSocialProvider = (str: any): str is SOCIAL_PROVIDERS => {
  if (typeof str === 'string') {
    const providers: string[] = Object.values(SOCIAL_PROVIDERS);
    if (providers.includes(str)) {
      return true;
    }
  }
  return false;
};
